export default __webpack_public_path__ + "static/media/help-icon.8fdbb28a.svg";